module.exports = __webpack_public_path__ + "img/test_r3.326fdb67.png";